'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = logger;
var LOG_INFO = false;
var LOG_ERROR = true;

function logger() {
    logger.info.apply(logger, arguments);
}

logger.info = function logInfo() {
    if (LOG_INFO) {
        var _window$console;

        (_window$console = window.console).log.apply(_window$console, arguments);
    }
};

logger.error = function logError() {
    if (LOG_ERROR) {
        var _window$console2;

        (_window$console2 = window.console).error.apply(_window$console2, arguments);
    }
};

logger.setLevel = function setLevel(newLevel) {
    if (newLevel === 0) {
        LOG_ERROR = false;
        LOG_INFO = false;
    } else if (newLevel === 1) {
        LOG_ERROR = true;
        LOG_INFO = false;
    } else if (newLevel === 2) {
        LOG_ERROR = true;
        LOG_INFO = true;
    }
};

logger.namespace = function namespace(label) {
    function namespacedLogger() {
        namespacedLogger.info.apply(namespacedLogger, arguments);
    }

    namespacedLogger.info = function logInfo() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var newArgs = args;
        newArgs[0] = '[' + label + '] ' + newArgs[0];
        logger.info.apply(logger, newArgs);
    };

    namespacedLogger.error = function logError() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        var newArgs = args;
        newArgs[0] = '[' + label + '] ' + newArgs[0];
        logger.error.apply(logger, newArgs);
    };

    return namespacedLogger;
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["Logger"]
window._kiwi_exports.libs.Logger = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/Logger.js
// module id = XNCV
// module chunks = 1